import React, {Component} from 'react';
import {connect} from 'react-redux';
import {FileUploader} from './file-uploader';
import Action from 'components/organisms/late-swap/actions';

class FileDataReceiver extends Component {
    handleUploadedFiles(files) {
        const {dispatch} = this.props;
        const [file] = files;

        const fileReader = new FileReader();

        fileReader.onloadend = function (data) {
            const {
                currentTarget: {result},
            } = data;

            dispatch(Action.do('processFileData', result));
        };

        fileReader.readAsText(file);
    }

    render() {
        return (
            <FileUploader handleUploadedFiles={this.handleUploadedFiles.bind(this)} accept={'.csv'} />
        );
    }
}

export default connect(() => ({}))(FileDataReceiver);
